import React, { useState } from "react";
import { APP_THEME } from "../theme/theme";
import Header from "../components/header";
import toast, { Toaster } from 'react-hot-toast';

const faqs = [
    {
        q: "How do I recharge my mobile?",
        a: "Go to Home, select 'Mobile Recharge', enter your 10-digit number, select your operator and circle, pick a plan or enter an amount, and click 'Recharge Now'. The amount will be deducted from your wallet.",
    },
    {
        q: "How long does recharge take?",
        a: "Most recharges are instant. However, sometimes operator delays can occur. If your recharge is pending, please wait for up to 30 minutes before raising a ticket.",
    },
    {
        q: "What if my recharge fails?",
        a: "If a recharge fails, any deducted amount is usually refunded to your wallet instantly. In case it's not refunded within 2 hours, please contact our support team with the transaction ID.",
    },
    {
        q: "How do I add money to wallet?",
        a: "Go to 'Add Money' from the Home screen or Profile. Enter the amount, select your preferred payment method (UPI, Debit Card, etc.), and complete the transaction. Your balance will update instantly.",
    },
    {
        q: "How does referral work?",
        a: "Share your unique referral code found in 'Refer & Earn' with friends. When they sign up using your code, you earn ₹50 and they get ₹25 as a welcome bonus once they complete their first transaction.",
    },
    {
        q: "How do I delete my account?",
        a: "You can delete your account by going to Profile > Account Deletion. Please note that this action is permanent and you will lose your wallet balance and transaction history.",
    },
];

function SupportCenter() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const handleEmailSupport = () => {
        const email = APP_THEME.support.emailSupport;
        window.location.href = `mailto:${email}?subject=Support Request - ${APP_THEME.appName}`;
    };

    const handleCallSupport = () => {
        const phone = APP_THEME.support.callSupport;
        window.location.href = `tel:${phone}`;
    };

    const handleWhatsAppSupport = () => {
        const whatsapp = APP_THEME.support.whatsAppSupport;
        window.location.href = whatsapp;
    }

    const handleChatSupport = () => {
        toast.success("Chat support coming soon!", {
            duration: 2000,
            position: "bottom-center",
            style: {
                background: APP_THEME.surfaceColor,
                color: APP_THEME.textPrimary,
                border: `1px solid ${APP_THEME.borderColor}`,
            },
        });
    };

    const ContactCard = ({ icon, label, sub, onClick }) => (
        <div
            onClick={onClick}
            className="rounded-2xl p-4 py-3 flex flex-col items-center cursor-pointer text-center transition-all duration-200 active:scale-98"
            style={{
                background: APP_THEME.bgColor,
                border: `1px solid ${APP_THEME.borderColor}`,
                borderRadius: APP_THEME.borderRadiusCard,
            }}
        >
            <div
                className="w-10 h-10 rounded-full flex items-center justify-center mb-2"
                style={{
                    background: APP_THEME.primaryLight,
                }}
            >
                {icon}
            </div>
            <span
                className="text-xs font-semibold"
                style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}
            >
                {label}
            </span>
            <span
                className="text-[10px]"
                style={{ color: APP_THEME.textSecondary, fontFamily: APP_THEME.fontFamily }}
            >
                {sub}
            </span>
        </div>
    );

    return (
        <>
            <Header title={"Support Center"} showBack={true} />
            <div className="p-4">
                {/* Contact Cards - Grid with 3 columns */}
                <div className="grid grid-cols-3 gap-3 mb-8">
                    <ContactCard
                        label="WhatsApp"
                        sub="Auto Support"
                        onClick={handleWhatsAppSupport}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                            </svg>
                        }
                    />
                    <ContactCard
                        label="Chat"
                        sub="Live Support"
                        onClick={handleChatSupport}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                            </svg>
                        }
                    />
                    <ContactCard
                        label="Email"
                        sub={APP_THEME.supportEmail ? "24h response" : "support@example.com"}
                        onClick={handleEmailSupport}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                            </svg>
                        }
                    />
                    <ContactCard
                        label="Call"
                        sub={APP_THEME.supportHours || "9am - 9pm"}
                        onClick={handleCallSupport}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                            </svg>
                        }
                    />
                </div>

                {/* FAQ Section */}
                <h3
                    className="text-sm font-bold mb-4"
                    style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}
                >
                    Frequently Asked Questions
                </h3>

                <div className="mb-8">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="overflow-hidden"
                            style={{
                                borderBottom: `1px solid ${APP_THEME.borderColor}`,
                            }}
                        >
                            <div
                                onClick={() => toggleAccordion(index)}
                                className="flex items-center justify-between py-4 cursor-pointer"
                            >
                                <span
                                    className="text-sm font-medium"
                                    style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}
                                >
                                    {faq.q}
                                </span>
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke={APP_THEME.textSecondary}
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="transition-transform duration-300"
                                    style={{
                                        transform: openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                                    }}
                                >
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </div>

                            <div
                                className="transition-all duration-300 ease-in-out overflow-hidden"
                                style={{
                                    maxHeight: openIndex === index ? "200px" : "0",
                                    opacity: openIndex === index ? 1 : 0,
                                    paddingBottom: openIndex === index ? "16px" : "0",
                                }}
                            >
                                <p
                                    className="text-xs leading-relaxed"
                                    style={{ color: APP_THEME.textSecondary, fontFamily: APP_THEME.fontFamily }}
                                >
                                    {faq.a}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Toaster position="bottom-center" />

            <style>
                {`
                    .active\\:scale-98:active {
                        transform: scale(0.98);
                    }
                `}
            </style>
        </>
    );
}

export default SupportCenter;